import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';
import { LoginGuard } from './login.guard';
import { ChangePasswordComponent } from './change-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

const routes: Routes = [
    { path: '', component: LoginComponent, canActivate: [LoginGuard] },
    { path: 'changepassword/:user', component: ChangePasswordComponent },
    { path: 'resetpassword', component: ResetPasswordComponent },
  ];

  export const loginRouting = RouterModule.forChild(routes);